var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('fa-icon',{attrs:{"icon":_vm.classIcon(_vm.insertion.advertisingSpace.media),"title":_vm.getLabel(_vm.insertion.advertisingSpace.media)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }